"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var React = _interopRequireWildcard(require("react"));
var _types = require("./types");
var _utils = require("../utils");
require("../../../src/ui/icon/icon.module.scss");
const _excluded = ["className", "size", "xlink"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// accessibility ok

const Icon = exports.Icon = /*#__PURE__*/React.forwardRef((props, ref) => {
  let {
      className,
      size,
      xlink
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  let Svg;
  const require24pxIcons = () => {
    const trySize = _types.EIconSize.SIZE_24;
    try {
      Svg = require("!!@svgr/webpack!../../../src/assets/icons/".concat(trySize, "/") + xlink + '.svg').default;
    } catch (e) {
      Svg = 'svg';
      console.error("svg with xlink ".concat(xlink, ", size ").concat(trySize, " not found"));
    }
  };
  if (size && (size === _types.EIconSize.SIZE_16 || size === _types.EIconSize.SIZE_96)) {
    try {
      Svg = require("!!@svgr/webpack!../../../src/assets/icons/".concat(size, "/") + xlink + '.svg').default;
    } catch (e) {
      require24pxIcons();
    }
  } else {
    require24pxIcons();
  }
  if (size === 16) size = null;
  const classNames = (0, _utils.ClassNames)('kui-icon', size ? 'kui-icon--' + size : null, className);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: classNames,
    ref: ref
  }, attributes), /*#__PURE__*/React.createElement(Svg, {
    className: "kui-icon__svg"
  }));
});
Icon.defaultProps = {
  xlink: '',
  size: _types.EIconSize.SIZE_16
};
Icon.displayName = 'Icon';